import { Component, Input, ViewChild, ContentChild, QueryList, ContentChildren, ElementRef, HostBinding } from '@angular/core';
import { SlideTitleComponent } from '../slide-title.component';
import { SlideFragmentComponent } from '../slide-fragment.component';
import { SlideFragment } from '../slide-fragment';
import {CLASS_FOCUS, CLASS_BLUR} from '../classes';
import { style, animate, state, transition, trigger, query, stagger } from '@angular/animations';

@Component({
  selector: 'code-slide',
  styleUrls: ['code-slide.component.css'],
  templateUrl: './code-slide.component.html',
  animations: [
    trigger('slideAnimation', [
      state('blur', style({ 'display':'none' })),
      transition('* => blur', [
        query('.content > *.fragment-active, .content > * .point', [
          stagger(100, [
            animate('300ms ease-out', style({ transform: 'translateX(-50px)', opacity: 0 }))
          ])
        ], { optional: true }),
        animate('1ms', style({opacity:1}))
      ]),
      transition('* => focus', [
        query('.content > *.fragment-active, .content > .point', [
          style({ opacity: 0 }),
          stagger(100, [
            animate('300ms ease-out', style({ opacity: 1 }))
          ])
        ], { optional: true }),
        animate('1ms', style({opacity:1}))
      ])
    ])
  ]
})
export class CodeSlideComponent {
  @HostBinding('@slideAnimation')
  public status = 'blur';

  @Input('skip-animation')
  public skipAnimation = false;

  @Input('type')
  public type = null;

  @Input('src')
  public src = '';

  public fragments: SlideFragment[] = [];
  public element: any;
  public code = '';

  constructor(element: ElementRef) {
    this.element = element.nativeElement;
    this.element.addEventListener('click', e => {
      e.stopPropagation();
      e.preventDefault();
    });
  }

  focus() {
    this.status = 'focus';
    this.element.classList.add(CLASS_FOCUS);
    this.element.classList.remove(CLASS_BLUR);
  }

  blur() {
    this.status = 'blur';
    this.element.classList.add(CLASS_BLUR);
    this.element.classList.remove(CLASS_FOCUS);
  }

  showAllFragments() {
    this.fragments.forEach(fragment => fragment.show());
  }

  hideAllFragments() {
    this.fragments.forEach(fragment => fragment.hide());
  }

  showFragment(index: number) {
    this.fragments.forEach((fragment, i) => {
      if (i <= index) {
        fragment.show();
      } else {
        fragment.hide();
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/code-slide/code-slide.component.ts